<db-dialog-wrapper [dialog]="this" [width]="'700px'" [canClose]="!removeLoading" [hasCloseButton]="!removeLoading"  [canCloseByBackdrop]="!removeLoading">
  <div class="db-confirm-dialog db-confirm-dialog-{{size}}">
    <div class="db-confirm-dialog__header">{{header}}</div>
    <div class="db-confirm-dialog__message">
      <p [innerHTML]="message"></p>
      <p *ngIf="!!cdnMessage" class="db-cdn-message" [innerHTML]="cdnMessage"></p>
      <span *ngIf="params && params.pluginsCount">{{params.pluginsCount}}</span>
      <span *ngIf="params && params.themesCount && params.pluginsCount"> and </span>
      <span *ngIf="params && params.themesCount">{{params.themesCount}}</span>
      <span *ngIf="params">?</span>
    </div>
    <div class="db-confirm-dialog__buttons">
      <a class="ds-btn ds-btn-m mr20" (click)="cancel()" [ngClass]="{'db-button_disabled': removeLoading}"><span>{{cancelButtonText}}</span></a>
      <a class="ds-btn-red ds-btn-m {{confirmButtonClass}}" (click)="removeDomain()">
        <span *ngIf="!removeLoading">{{confirmButtonText}}</span>
        <db-loading-circular-spinner class="sl-confirm-remove-domain-loader" *ngIf="removeLoading"></db-loading-circular-spinner>
      </a>
    </div>
  </div>
</db-dialog-wrapper>
